import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import Pagination from "./Pagination"
import Loader from "./elements/Loader"

export default function Serp() {
    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0
    const toggleButtonId = "toggle-mobile-sidebar"

    if(window.innerWidth < 480 && document.querySelector("header-search-popdown.is-open")){
        document.querySelector(".search-popdown__close__button")?.click();
    } else if(window.innerWidth < 480 && document.querySelector(".drawer.drawer--header.is-open")) {
        document.querySelector(".drawer .drawer__close")?.click();
    }
    
    return (
        <div class="ns-serp ns-d-flex ns-flex-column ns-font-inherit ns-mx-auto" data-nosto-element="search" id="Collection--template--nosto" data-section-id="template--nosto">
            <div class="collection__title collection__title--no-image align--middle-center"><h1 class="hero__title h4">{products?.categoryPath}</h1></div>
            {foundProducts && <Toolbar lableFor={toggleButtonId} />}
            <div class="ns-d-flex ns-w-100 ns-border-box">
                {foundProducts ? (
                    <>
                        <div class="collection__products">
                            <Sidebar toggleId={toggleButtonId} />
                            <Products />
                        </div>
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )}
            </div>
            <Pagination />
    </div>
    )
}
